/**
 * Libellés sûrs pour les ouvertures de classe (évite React error #31).
 * L'API peut renvoyer `classe` comme chaîne ou comme objet imbriqué.
 */
export function getClasseLabel(item, fallback = '') {
  if (!item) return fallback;
  if (typeof item.classe_nom === 'string' && item.classe_nom) return item.classe_nom;
  if (typeof item.classe === 'string' && item.classe) return item.classe;
  if (item.classe && typeof item.classe === 'object') {
    return item.classe.classe || item.classe.abrev || item.classe.nom || fallback;
  }
  if (item.classe_id != null && item.classe_id !== '') return String(item.classe_id);
  return fallback;
}

export function getEnseignementLabel(item, fallback = '') {
  if (!item) return fallback;
  if (typeof item.enseignement_nom === 'string' && item.enseignement_nom) return item.enseignement_nom;
  if (typeof item.enseignement === 'string' && item.enseignement) return item.enseignement;
  const ens = item.classe?.enseignement;
  if (ens && typeof ens === 'object') {
    return ens.enseignement || ens.description || ens.nom || fallback;
  }
  if (item.enseignement_id != null && item.enseignement_id !== '') return String(item.enseignement_id);
  return fallback;
}

export function getNiveauLabel(item, fallback = '') {
  if (!item) return fallback;
  if (typeof item.niveau_nom === 'string' && item.niveau_nom) return item.niveau_nom;
  if (typeof item.niveau === 'string' && item.niveau) return item.niveau;
  const niv = item.classe?.niveau;
  if (niv && typeof niv === 'object') {
    return niv.niveau || niv.description || niv.nom || fallback;
  }
  if (item.classe?.niveau_id != null && item.classe.niveau_id !== '') return String(item.classe.niveau_id);
  return fallback;
}
